import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/50' : 'bg-transparent'}`} data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-190">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-191">
            <img src="https://cdn.magicpatterns.com/uploads/7KGG45Zf29JRX1VVso6grv/karchek.jpg" alt="Kerchak Fighters Team" className="h-10 w-10 rounded-full object-cover" data-id="element-192" />
            <div className="hidden sm:block" data-id="element-193">
              <span className="font-heading text-white font-bold text-sm tracking-widest uppercase leading-tight block" data-id="element-194">
                Kerchak Fighters Team
              </span>
              <span className="text-[#C9A84C] text-xs tracking-widest uppercase font-body" data-id="element-195">
                Boxeo · MMA · K1
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-196">
            <a href="#para-quien" className="text-gray-400 hover:text-white transition-colors duration-200 font-body text-sm tracking-wide" data-id="element-197">
              Para quién
            </a>
            <a href="#como-funciona" className="text-gray-400 hover:text-white transition-colors duration-200 font-body text-sm tracking-wide" data-id="element-198">
              Cómo funciona
            </a>
            <a href="#precios" className="text-gray-400 hover:text-white transition-colors duration-200 font-body text-sm tracking-wide" data-id="element-199">
              Precios
            </a>
            <a href="#faq" className="text-gray-400 hover:text-white transition-colors duration-200 font-body text-sm tracking-wide" data-id="element-200">
              FAQ
            </a>
            <a href="#precios" className="bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-6 py-2.5 text-sm tracking-widest uppercase transition-all duration-200" data-id="element-201">
              Reservar Clase
            </a>
          </div>

          {/* Mobile menu button */}
          <button className="md:hidden text-white p-2" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" data-id="element-202">
            {menuOpen ? <XIcon size={24} data-id="element-203" /> : <MenuIcon size={24} data-id="element-204" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && <div className="md:hidden bg-[#0a0a0a]/98 backdrop-blur-md border-t border-[#2a2a2a]" data-id="element-205">
          <div className="px-4 py-6 flex flex-col gap-4" data-id="element-206">
            <a href="#para-quien" onClick={() => setMenuOpen(false)} className="text-gray-300 font-body py-2 border-b border-[#1a1a1a]" data-id="element-207">
              Para quién
            </a>
            <a href="#como-funciona" onClick={() => setMenuOpen(false)} className="text-gray-300 font-body py-2 border-b border-[#1a1a1a]" data-id="element-208">
              Cómo funciona
            </a>
            <a href="#precios" onClick={() => setMenuOpen(false)} className="text-gray-300 font-body py-2 border-b border-[#1a1a1a]" data-id="element-209">
              Precios
            </a>
            <a href="#faq" onClick={() => setMenuOpen(false)} className="text-gray-300 font-body py-2 border-b border-[#1a1a1a]" data-id="element-210">
              FAQ
            </a>
            <a href="#precios" onClick={() => setMenuOpen(false)} className="bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-6 py-3 text-center tracking-widest uppercase transition-all duration-200 mt-2" data-id="element-211">
              Reservar Clase
            </a>
          </div>
        </div>}
    </nav>;
}